const LANG_PARAM = {
	'zh-TW': '',
	'zh-CN': '&ch=lang_cn',
	en: '&ch=lang_en',
	ja: '&ch=lang_ja',
	ko: '&ch=lang_ko',
};

const BASE_URLS = {
	ximending: 'https://reg01l200101.southeastasia.cloudapp.azure.com/wise/webchat/default/?t=%2BZBuJE8oPaveaNMQjdEoOQ%3D%3D',
	NTU: 'https://reg01l200101.southeastasia.cloudapp.azure.com/wise/webchat/default/?t=71Kryn8tkuHd5xfqhen9aw%3D%3D',
	jiaoxi: 'https://reg01l200101.southeastasia.cloudapp.azure.com/wise/webchat/default/?t=oC56ls9rDQCvE6pSN%2B9i0w%3D%3D',
	osakaShinsaibashi: 'https://reg01l200101.southeastasia.cloudapp.azure.com/wise/webchat/default/?t=%2BqBC9BCrmLROSWts0rsUXg%3D%3D',
	zhongshan: 'https://reg01l200101.southeastasia.cloudapp.azure.com/wise/webchat/default/?t=KiJw8%2BHC9sYC%2BQ7%2FSDTLjw%3D%3D',
};

const TEXT = {
	'zh-TW': '您好，歡迎在此提出問題，捷絲旅小管家很樂意為您解答。',
	'zh-CN': '您好，欢迎在此提出问题，捷丝旅小管家很乐意为您解答。',
	en: 'Hello! Please feel free to leave your questions here. We will be happy to assist you.',
	ja: 'こんにちは！どのようなことでも、お気軽にご相談ください。',
	ko: '안녕하세요. 문의사항이 있으시면 언제든지 말씀해 주세요. 친절하게 안내해 드리겠습니다.',
};

const TEXT_OSAKA_JA = 'こんにちは。ご不明な点がございましたら、こちらでお気軽にご質問ください。ホテルがご案内いたします。';

// Wave 1 (6/22): ximending, NTU, jiaoxi, osakaShinsaibashi
// Wave 2 (7/1): add 'zhongshan'
export const CHATBOT_HOTELS = ['ximending', 'NTU', 'jiaoxi', 'osakaShinsaibashi'];

export const getChatbotConfig = (hotel, lan) => {
	if (!CHATBOT_HOTELS.includes(hotel)) return null;
	const baseUrl = BASE_URLS[hotel];
	const url = baseUrl + (LANG_PARAM[lan] || '');
	const text = hotel === 'osakaShinsaibashi' && lan === 'ja' ? TEXT_OSAKA_JA : TEXT[lan] || TEXT['zh-TW'];
	return { url, text };
};



// WEBPACK FOOTER //
// ./src/components/molecules/ChatbotWidget/config.js